export const COUNTRIES = {
  MY: {
    code: 'MY',
    name: 'Malaysia',
    flag: '🇲🇾',
    currency: 'MYR',
    currencySymbol: 'RM',
    phonePrefix: '+60',
    administrativeDivisionLabel: 'State',
    // Keep existing Malaysian validation rules for all countries as per backend.md
  },
  SG: {
    code: 'SG', 
    name: 'Singapore',
    flag: '🇸🇬',
    currency: 'SGD',
    currencySymbol: 'S$',
    phonePrefix: '+65',
    administrativeDivisionLabel: 'District',
  },
  PH: {
    code: 'PH',
    name: 'Philippines',
    flag: '🇵🇭',
    currency: 'PHP',
    currencySymbol: '₱',
    phonePrefix: '+63',
    administrativeDivisionLabel: 'Province',
  },
  ID: {
    code: 'ID',
    name: 'Indonesia',
    flag: '🇮🇩',
    currency: 'IDR',
    currencySymbol: 'Rp',
    phonePrefix: '+62',
    administrativeDivisionLabel: 'Province',
  },
  IN: {
    code: 'IN',
    name: 'India',
    flag: '🇮🇳',
    currency: 'INR',
    currencySymbol: '₹',
    phonePrefix: '+91',
    administrativeDivisionLabel: 'State',
  },
  VN: {
    code: 'VN',
    name: 'Vietnam',
    flag: '🇻🇳',
    currency: 'VND',
    currencySymbol: '₫',
    // Large-denomination currency: hourly rates run to 6+ digits
    priceMaxLength: 8,
    phonePrefix: '+84',
    administrativeDivisionLabel: 'Province',
  },
  KH: {
    code: 'KH',
    name: 'Cambodia',
    flag: '🇰🇭',
    // Cambodian salaries are quoted in US dollars rather than riel
    currency: 'USD',
    currencySymbol: '$',
    phonePrefix: '+855',
    administrativeDivisionLabel: 'Province',
  },
  TH: {
    code: 'TH',
    name: 'Thailand',
    flag: '🇹🇭',
    currency: 'THB',
    currencySymbol: '฿',
    phonePrefix: '+66',
    administrativeDivisionLabel: 'Province',
  },
  LA: {
    code: 'LA',
    name: 'Laos',
    flag: '🇱🇦',
    currency: 'LAK',
    currencySymbol: '₭',
    // Large-denomination currency: hourly rates run to 6+ digits
    priceMaxLength: 8,
    phonePrefix: '+856',
    administrativeDivisionLabel: 'Province',
  },
  USD: {
    code: 'USD',
    name: 'United States Dollar',
    flag: '🇺🇸',
    currency: 'USD',
    currencySymbol: '$',
    phonePrefix: '+1',
    administrativeDivisionLabel: 'State',
  }
};

// Default country for existing users
export const DEFAULT_COUNTRY = 'MY';

// List of enabled countries (can be controlled by feature flag later)
export const ENABLED_COUNTRIES = ['MY', 'SG', 'PH', 'ID', 'IN', 'VN', 'KH', 'TH', 'LA'];

// Country list for dropdowns
export const COUNTRY_OPTIONS = ENABLED_COUNTRIES.map(code => ({
  label: `${COUNTRIES[code].flag} ${COUNTRIES[code].name}`,
  value: code,
}));

// Helper to get country data
export const getCountryData = (countryCode) => {
  return COUNTRIES[countryCode] || COUNTRIES[DEFAULT_COUNTRY];
};

// Helper to get administrative division label (State/District/Province)
export const getAdministrativeDivisionLabel = (countryCode) => {
  const country = COUNTRIES[countryCode] || COUNTRIES[DEFAULT_COUNTRY];
  return country.administrativeDivisionLabel || 'State';
};